
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import LazyImage from '../LazyImage.vue';

@Options({
  components: {
    LazyImage
  },
  data() {
    return {
      starFavorite: require('@/assets/images/star-favorite.svg')
    };
  }
})
export default class MDiscountAvailable extends mixins(CartWidgetMixin) {
  get starFavorite() {
    if (this.customStarImage) {
      return this.customStarImage;
    } else {
      return require('@/assets/images/star-favorite.svg');
    }
  }

  get discountAvailableTitle() {
    if (this.nftAvailableTitle) {
      return this.nftAvailableTitle;
    } else {
      return 'Discount Available';
    }
  }

  get discountAvailableMessage() {
    if (this.nftAvailableMessage) {
      return this.nftAvailableMessage;
    } else {
      return 'LFG! Apply Discount for more info';
    }
  }
}
